<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-app>
        <resizable-page>
          <template v-slot:table="tableProps">
            <v-card>
              <!-- <v-card-title>
                Client Master List
              </v-card-title> -->
              <v-card-title>
                <v-btn
                  color="primary"
                  dark
                  class="ma-2"
                  @click="addVehicle"
                >
                  Add Payment Plan
                </v-btn>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="ma-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Export To XLS
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item link>
                      <downloadExcel
                        :data="dataExport(table)"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        All Record
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item link>
                      <downloadExcel
                        :data="exportDisplayedPage"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        Displayed record
                      </downloadExcel>
                    </v-list-item>
                    <v-list-item link>
                      <downloadExcel
                        :data="exportAllFitered"
                        :fields="field_export"
                        :worksheet="worksheetName"
                        :name="fileName"
                      >
                        All filtered record
                      </downloadExcel>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                mobile-breakpoint
                single-expand
                show-expand
                :headers="headers"
                :items="table"
                :search="search"
                :loading="loadTable"
                loading-text="Loading... Please wait"
                @current-items="getFiltered"
                ref="vTable"
                :height="tableProps.tableHeight"
                fixed-header
                :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
                :options="{'itemsPerPage':10}"
                
              >
              
                <!-- <template v-slot:[`item.payment_plan_type`]="{ item }">
                  <span v-if="item.payment_plan_type==1">Yellow Plate</span>
                  <span v-if="item.payment_plan_type==2">Black Plate</span>
                  <span v-if="item.payment_plan_type==3">BP Ownership</span>
                </template> -->

                <template v-slot:[`item.vehicle`]="{ item }">
                  <p>{{ item.vehicle_type.vehicle_brands.vehicle_brand_name+"-"+item.vehicle_type.vehicle_model+" "+item.vehicle_type.vehicle_year_model }}</p>
                </template>
            

                <template  v-slot:expanded-item="{ headers, item }">
                  <td class="pa-5" :colspan="headers.length">
                  <!-- Faktur are closed: -->
                    <md-table class="ma-5">
                      <md-table-row >
                        <md-table-head style="text-align: center;"><b>Week</b></md-table-head>
                        <md-table-head style="text-align: center;"><b>Installment</b></md-table-head>
                      </md-table-row>
                      <!-- <md-table-row  v-for="(items, index)  in item.installment" :key="index"> -->
                      <md-table-row  v-for="(items, index) in item.installment" :key="index">

                        <md-table-cell style="text-align: center;">{{ items.payment_plan_installment_week }}</md-table-cell>
                        <md-table-cell style="text-align: center;"><span>Rp.</span><span>{{ formatPrice(items.payment_plan_installment_amount) }}</span>
                        </md-table-cell>
                      </md-table-row>
                      <!-- <md-table-row  >

                        <md-table-cell style="text-align: center;">{{ item.installment.payment_plan_installment_week }}</md-table-cell>
                        <md-table-cell style="text-align: center;"><span>Rp.</span><span>{{ formatPrice(item.installment.payment_plan_installment_amount) }}</span>
                        </md-table-cell>
                      </md-table-row> -->
                    </md-table>
                  </td>
                </template>
              
              </v-data-table>
            </v-card>
          </template>
        </resizable-page>
      </v-app>
      <modal ref="openModalAdd">
        <template v-slot:header>
          <div style="text-align:center; margin:auto; ">
            <h3>ADD PAYMENT PLAN</h3>
          </div>
          <md-button
            class="md-icon-button md-dense md-round"
            @click="modalCloseAdd()"
          >
            <md-icon>close</md-icon>
          </md-button>
        </template>
        <template v-slot:body>
          <add-payment-plan />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";
import Swal from "sweetalert2";
import { Modal } from "@/components";
import AddPaymentPlan from "@/pages/Dashboard/Fms/PaymentPlan/AddPPPage.vue";
import JsonExcel from "vue-json-excel";


const toLower = (text) => {
  var rt = "";
  if (text) {
    rt = text.toString().toLowerCase();
  }
  return rt;
};
export default {
  components: {
    downloadExcel: JsonExcel,
    ResizablePage,
    Modal,
    "add-payment-plan" : AddPaymentPlan
  },
  vuetify,
  data: () => ({
    loadTable: true,
        role: "",
        search: '',
        headers: [
          // {
          //   text: 'Payment Plan No',
          //   align: 'start',
          //   value: 'dp_amount_no',
          // },
          { text: '', value: 'data-table-expand' },
          { text: 'Payment Plan Name', value: 'payment_plan_name', align: 'center' },
          // { text: 'Payment Plan Type', value: 'payment_plan_type', align: 'center' },
          { text: 'Vehicle Type', value: 'vehicle', align: 'center' },
          // { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        table: [],
        worksheetName: "Payment Plan",
        fileName:"Payment Plan.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
          'payment_plan_name': 'payment_plan_name',
                    
    },
  }),


  created() {
    this.getList();
  },

  methods: {
    // ambil data yang dibutuhkan
    async getList() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      await this.$store.dispatch("fms_payment_plan/list");

      if (
        (await this.$store.getters["fms_payment_plan/list"]) &&
        (await this.$store.getters["fms_payment_plan/list"].length) != 0
      ) {
        this.table = await this.$store.getters["fms_payment_plan/list"];
      }
      this.loadTable= false
    },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    if(this.$refs.vTable){
      this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    }
    else{
      this.exportAllFitered = this.dataExport(this.table)
    }
    },

    modalOpenList(id, name) {
      this.$refs.modalList.openModal({ id: id, name: name });
    },

    modalOpenEditFormDp(id) {
      // panggil edit page
     this.$router.push({ name: "Edit Payment Plan", params: { id: id } });
    },

    formatPrice(value) {
      let val = (value/1).toFixed().replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    // fungsi add data
    addVehicle() {
      // panggil add page
      // this.$router.push({ name: "Add Payment Plan" });
      this.$refs.openModalAdd.openModal();
    },

    modalCloseAdd(){
      this.$refs.openModalAdd.closeModal();
      this.getList();
    },

    // fungsi edit data
    editVehicle(id) {
      // panggil edit page
      this.$router.push({ name: "Edit Payment Plan", params: { id: id } });
    },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteVehicle(id);
        }
      });
    },

    // fungsi delete data 
    async deleteVehicle(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("fms_payment_plan/destroy", id);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Payment Plan data delete successfully."
        );
        //await this.getList();
        var indexOptionTable = this.table.findIndex(p => p.id ==  id)
          var indexOptionTablePage = this.tablePage.findIndex(p => p.id ==  id)
           this.table.splice(indexOptionTable, 1)
           this.tablePage.splice(indexOptionTablePage, 1)
           this.total = this.table.length
           this.dataExport(this.table, "all");
          this.dataExport(this.table, "filter");
          this.dataExport(this.tablePage, "page");
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
    dataExport(data, jenis) {
      data = data.map((v, index) => ({ ...v, no: index + 1 }));
      if (jenis == "all") {
        this.dataExsport = [];
        this.dataExsport = data;
      } else if (jenis == "filter") {
        this.dataExsportFilter = [];
        this.dataExsportFilter = data;
      } else if (jenis == "page") {
        this.dataExsportPage = [];
        this.dataExsportPage = data;
      }
      // console.log(data)
    },
  },
};
</script>
<style>
#pro-feature {
  font-weight: bold;
}

.nodata{
  text-align:center;
  color:#aaa;
}
</style>
